import { W4D_Nav_Swipe } from './w4d-nav-swipe';

const slinkyOptions = {
	title: true,
	speed: 300,
	resize: true,
	activeClass: 'active',
};

(function ($) {
	class W4D_Nav {
		constructor() {
			if ($('body').hasClass('page-template-page-checkout')) {
				return;
			}

			this.init();
		}

		init() {
			this.initSelectors();
			this.initOriginalToggleText();
			this.initSlinky();
			this.bindEvents();
			this.checkInitialHover();
			this.checkActiveCategory();
			this.initLanguageTaxSelectorPosition();
			this.initOverlayStickyHeader();

			// Instantiate swipe handler class
			this.swipeHandler = new W4D_Nav_Swipe(this.$navInner, this.$header, () => this.closeNav());
		}

		// Initialization methods
		initSelectors() {
			this.$header = $('.w4d-header');
			this.$navToggle = $('.nav > .nav__toggle');
			this.$menu = $('[data-slinky-menu]');
			this.$navInner = $('.nav__inner');
			this.$navLinksWrapper = $('.nav__links-wrapper');
			this.$megaMenuToggleWrapper = this.$header.find('.nav__toggle-wrapper');
			this.$megaMenuToggle = this.$megaMenuToggleWrapper.find('.nav__toggle');
			this.$megaMenuToggleText = this.$megaMenuToggleWrapper.find('.nav__toggle-text');
			this.$megaMenu = this.$header.find('.nav--3');
			this.$headerType3CategoryItems = this.$megaMenu.find('.nav__links-wrapper > ul > li').not('[data-variant]');
			this.myAccountMobileBtn = $('[data-js-my-account-mobile-trigger]');
			this.myAccountMobileBtnOriginalContent = this.myAccountMobileBtn.length ? this.myAccountMobileBtn.html() : '';
		}

		initOriginalToggleText() {
			this.originalToggleText = this.$megaMenuToggleText.length ? this.$megaMenuToggleText.text() : '';
		}

		initSlinky() {
			const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

			if (mediaQueryXl.matches) {
				this.slinky = this.$menu.slinky(slinkyOptions);
				this.$menu.find('li[data-variant="topbar"] .header').remove();
			}
		}

		initLanguageTaxSelectorPosition() {
			this.mediaQueryXl = window.matchMedia('(max-width: 1400px)');
			this.$languageTaxSelector = $('.w4d-header__btn[popovertarget="language-tax-selector"]');
			this.$mobileNavButtonGroup = $('.nav__btn-group');
			this.$headerCartIcon = $('#header_cart_icon');

			if (!this.$languageTaxSelector.length || !this.$mobileNavButtonGroup.length || !this.$headerCartIcon.length) {
				return;
			}

			this.moveLanguageTaxSelector(this.mediaQueryXl.matches);
			this.mediaQueryXl.addEventListener('change', (event) => {
				this.moveLanguageTaxSelector(event.matches);
			});
		}

		initOverlayStickyHeader() {
			const header = this.$header[0];
			if (!header) {
				return;
			}

			const OVERLAY_CLASS = 'w4d-overlay-active';
			const desktopBreakpoint = window.matchMedia('(min-width: 1400px)');

			// DOM query only runs from (rare) overlay events — never from the scroll handler.
			const queryActiveOverlay = () =>
				desktopBreakpoint.matches &&
				Boolean(
					document.querySelector('.dgwt-wcas-open, .login-popover:popover-open, .ltp-popover:popover-open') ||
					document.querySelector('.dgwt-wcas-suggestions-wrapp:not([style*="display: none"])')
				);

			let overlayActive = false;
			let overlayWasActive = false;
			let previousScrollY = null; // read lazily: window.scrollY at init forces a layout flush

			const setOverlayActive = (isActive) => {
				if (overlayActive === isActive) {
					return;
				}

				overlayActive = isActive;
				document.body.classList.toggle(OVERLAY_CLASS, isActive);
			};

			const retainVisibilityAfterClose = () => {
				setOverlayActive(queryActiveOverlay());

				if (!header.classList.contains('w4d-header--sticky') || !overlayWasActive || overlayActive) {
					return;
				}

				header.classList.remove('w4d-header--hidden');
				document.body.classList.remove('w4d-header-hidden');
				overlayWasActive = false;
			};

			const checkOverlayState = () => {
				if (queryActiveOverlay()) {
					setOverlayActive(true);
					overlayWasActive = true;
					header.classList.remove('w4d-header--hidden');
					document.body.classList.remove('w4d-header-hidden');
					return;
				}

				requestAnimationFrame(retainVisibilityAfterClose);
			};

			document.addEventListener('toggle', checkOverlayState, true);
			document.addEventListener('fibosearch/open', checkOverlayState);
			document.addEventListener('fibosearch/show-suggestions', checkOverlayState);
			document.addEventListener('fibosearch/show-pre-suggestions', checkOverlayState);
			document.addEventListener('fibosearch/close', checkOverlayState);
			desktopBreakpoint.addEventListener('change', checkOverlayState);

			window.addEventListener(
				'scroll',
				() => {
					const currentScrollY = window.scrollY;
					const isScrollingDown = previousScrollY !== null && currentScrollY > previousScrollY;
					previousScrollY = currentScrollY;

					// Only re-verify against the DOM while we believe an overlay is open,
					// so a suggestions panel hidden without an event can't leave the class stuck.
					if (overlayActive && !queryActiveOverlay()) {
						setOverlayActive(false);
					}

					if (isScrollingDown && !overlayActive) {
						overlayWasActive = false;
					}
				},
				{ passive: true }
			);

			checkOverlayState();
		}

		// Event binding
		bindEvents() {
			// Swap in the mobile account content when its trigger is activated.
			this.myAccountMobileBtn.on('click', (e) => this.handleMyAccountMobileBtnClick(e));

			const navL1List = this.$header.find('.nav__links-wrapper > ul').get(0);

			if (navL1List && !this.isHeaderType3()) {
				// Keep the desktop dropdown state aligned with pointer movement.
				navL1List.addEventListener('mouseover', (e) => this.handleNavL1ListHover(e));
				navL1List.addEventListener('mouseleave', (e) => this.handleNavL1ListHover(e));
			}

			if (this.$navToggle.length) {
				// Open or close the primary navigation from its toggle.
				this.$navToggle.on('click', (e) => this.handleNavToggleClick(e));
			}

			// Reinitialize the responsive menu after resizing settles.
			$(window).on('resize', () => this.handleWindowResize());

			// Toggle the category mega menu from its dedicated control.
			this.$megaMenuToggleWrapper.on('click', () => this.toggleMegaMenu());

			if (this.isHeaderType3()) {
				this.$headerType3CategoryItems.on('click', (e) => this.handleHeaderType3CategoryClick(e));
				this.$headerType3CategoryItems.children('a').on('keydown', (e) => this.handleHeaderType3CategoryKeydown(e));
				this.$megaMenu.on('click', (e) => this.handleNavContainerClick(e));
			}

			// Close the open navigation when its backdrop is clicked.
			$('.nav__container').on('click', (e) => this.handleNavContainerClick(e));

			if (!this.isHeaderType3()) {
				// Size desktop submenus while the pointer enters or leaves the list.
				$('.nav__links-wrapper > ul > li').on('mouseenter', (e) => {
					this.logExpandedNavHeight($(e.currentTarget));
				});

				$('.nav__links-wrapper > ul').on('mouseleave', (e) => {
					this.clearExpandedNavHeight($(e.currentTarget));
				});
			}

			// Let Escape close an open mega menu before closing the navigation.
			$(document).on('keyup', (e) => this.handleDocumentKeyup(e));

			// Return mobile slinky navigation to its top level after selecting an item.
			$(document).on('click', '.nav__links-wrapper li', () => this.handleMobileNavItemClick());
		}

		// Navigation methods
		checkInitialHover() {
			if (this.isHeaderType3()) return;

			const navL1List = this.$header.find('.nav__links-wrapper > ul').get(0);

			if (navL1List) {
				const hoveredL1Item = Array.from(navL1List.children).find((item) => item.matches(':hover')) || null;
				this.setNavDropdownState(navL1List, hoveredL1Item);
			}

			this.$header.addClass('w4d-header--nav-ready');
		}

		checkActiveCategory() {
			if (!this.isHeaderType3()) {
				return;
			}

			this.$headerType3CategoryItems.children('a').attr('aria-expanded', 'false');

			const activeCategorySlug = this.$megaMenuToggle.attr('data-active-main-category');
			if (activeCategorySlug) {
				this.highlightActiveCategory(activeCategorySlug);
			}
		}

		handleNavL1ListHover(e) {
			if (!window.matchMedia('(min-width: 1400px)').matches) {
				return;
			}

			const navL1List = e.currentTarget;
			const topL1Item = e.type === 'mouseleave' ? null : e.target.closest('.nav__links-wrapper > ul > li');
			this.setNavDropdownState(navL1List, topL1Item);
		}

		handleMyAccountMobileBtnClick(e) {
			const btn = e.currentTarget;
			const template = btn.querySelector('template');

			if (template) {
				const currentContent = Array.from(btn.childNodes).filter((node) => node !== template);
				const templateContent = template.content.cloneNode(true);

				template.content.replaceChildren(...currentContent.map((node) => node.cloneNode(true)));
				currentContent.forEach((node) => node.remove());
				btn.insertBefore(templateContent, template);
			}
		}

		handleNavToggleClick(e) {
			e.preventDefault();
			this.toggleNav();
		}

		handleHeaderType3CategoryClick(e) {
			if (!window.matchMedia('(min-width: 1400px)').matches || e.target.closest('li') !== e.currentTarget) {
				return;
			}

			const directLink = e.currentTarget.querySelector(':scope > a');
			if (e.target.closest('a') === directLink) {
				e.preventDefault();
			}

			const $clickedItem = $(e.currentTarget);
			if ($clickedItem.attr('data-submenu') === 'open') {
				return;
			}

			this.setHeaderType3Submenu($clickedItem, true);
		}

		handleHeaderType3CategoryKeydown(e) {
			if (e.key !== ' ' || !window.matchMedia('(min-width: 1400px)').matches) {
				return;
			}

			e.preventDefault();
			$(e.currentTarget).trigger('click');
		}

		handleWindowResize() {
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = setTimeout(() => {
				this.reinitSlinkyOnResize();
			}, 150);
		}

		handleNavContainerClick(e) {
			if (e.target === e.currentTarget) {
				if (this.isHeaderType3()) {
					this.toggleMegaMenu();
				} else {
					this.toggleNav();
				}
			}
		}

		handleDocumentKeyup(e) {
			if (e.key !== 'Escape') {
				return;
			}

			if (this.isHeaderType3()) {
				if (this.$megaMenu.hasClass('nav--open')) {
					this.toggleMegaMenu();
					return;
				}
			}

			if (this.$header.hasClass('w4d-header--open')) {
				this.toggleNav();
			}
		}

		handleMobileNavItemClick() {
			const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

			if (mediaQueryXl.matches && this.slinky) {
				this.scrollNavToTop();
			}
		}

		reinitSlinkyOnResize() {
			const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

			if (mediaQueryXl.matches && !this.slinky) {
				this.slinky = this.$menu.slinky(slinkyOptions);
				this.$menu.find('li[data-variant="topbar"] .header').remove();

				this.closeNav();
			} else if (!mediaQueryXl.matches && this.slinky) {
				if (typeof this.slinky.destroy === 'function') {
					this.slinky.destroy();
					this.slinky = null;
				}

				this.closeNav();
			}
		}

		toggleMegaMenu() {
			if (this.$megaMenuToggleWrapper.is(':hidden')) return;

			this.$megaMenu.toggleClass('nav--open');
			this.$megaMenuToggle.toggleClass('nav__toggle--open');

			if (this.$megaMenu.hasClass('nav--open')) {
				this.$megaMenuToggleText.text(this.$megaMenuToggleText.attr('data-close-text'));

				const $activeItem = this.$headerType3CategoryItems.filter('[data-submenu="open"]');
				if (!$activeItem.length) {
					const $firstNavItem = this.$headerType3CategoryItems.first();
					if ($firstNavItem.length) {
						this.setHeaderType3Submenu($firstNavItem, true);
					}
				}
			} else {
				this.$megaMenuToggleText.text(this.originalToggleText);
			}
		}

		toggleNav() {
			this.$header.toggleClass('w4d-header--open');
			this.$navToggle.toggleClass('nav__toggle--open');

			this.myAccountMobileBtn.each((index, btn) => {
				const $btn = $(btn);
				if ($btn.html() !== this.myAccountMobileBtnOriginalContent) {
					$btn.html(this.myAccountMobileBtnOriginalContent);
				}
			});
		}

		closeNav() {
			this.$header.removeClass('w4d-header--open');
			this.$navToggle.removeClass('nav__toggle--open');

			if (this.$navInner && this.$navInner[0]) {
				this.$navInner[0].style.transform = '';
				this.$navInner[0].style.transition = '';
			}

			this.myAccountMobileBtn.each((index, btn) => {
				$(btn).html(this.myAccountMobileBtnOriginalContent);
			});
		}

		// Helper methods
		isHeaderType3() {
			return this.$header.attr('data-header-type') === '3';
		}

		moveLanguageTaxSelector(isBelowXl) {
			if (isBelowXl) {
				this.$mobileNavButtonGroup.append(this.$languageTaxSelector);
			} else {
				this.$headerCartIcon.after(this.$languageTaxSelector);
			}
		}

		setNavDropdownState(navL1List, activeL1Item) {
			if (activeL1Item === this.activeL1Item) return;
			this.activeL1Item = activeL1Item;

			const l1Links = navL1List.querySelectorAll(':scope > li > a');

			if (!activeL1Item) {
				l1Links.forEach((link) => link.setAttribute('aria-expanded', 'false'));
				this.$header.get(0).style.setProperty('--dropdown-height', '0px');
				return;
			}

			const l2List = activeL1Item.querySelector(':scope > ul');
			const l1Link = activeL1Item.querySelector(':scope > a');
			const hasL3List = !!activeL1Item.querySelector(':scope > ul > li > ul');

			if (l2List && l1Link) {
				l1Link.setAttribute('aria-expanded', 'true');
				l1Links.forEach((link) => {
					if (link !== l1Link) {
						link.setAttribute('aria-expanded', 'false');
					}
				});

				// Only expand the full header backdrop for 3-level mega menus
				if (hasL3List) {
					const maxHeight = window.innerHeight * 0.72;
					const targetHeight = Math.min(l2List.scrollHeight, maxHeight);
					this.$header.get(0).style.setProperty('--dropdown-height', `${targetHeight}px`);
				} else {
					this.$header.get(0).style.setProperty('--dropdown-height', '0px');
				}
			} else {
				this.activeL1Item = null;
				l1Links.forEach((link) => link.setAttribute('aria-expanded', 'false'));
				this.$header.get(0).style.setProperty('--dropdown-height', '0px');
			}
		}

		highlightActiveCategory(categorySlug) {
			let $matchingItem = $();

			this.$headerType3CategoryItems.children('a').each(function () {
				const href = $(this).attr('href');
				if (!href) {
					return;
				}

				try {
					const pathSegments = new URL(href, window.location.origin).pathname.split('/').filter(Boolean);
					const linkedCategorySlug = decodeURIComponent(pathSegments.pop() || '');

					if (linkedCategorySlug === categorySlug) {
						$matchingItem = $(this).parent();
						return false;
					}
				} catch {
					return;
				}
			});

			if ($matchingItem.length) {
				this.setHeaderType3Submenu($matchingItem, true);
			}
		}

		setHeaderType3Submenu($activeItem, shouldOpen) {
			this.$headerType3CategoryItems.each(function () {
				const $item = $(this);
				$item.removeAttr('data-submenu');
				$item.children('a').first().removeClass('nav__link--active').attr('aria-expanded', 'false');
			});

			if (shouldOpen && $activeItem.length) {
				$activeItem.attr('data-submenu', 'open');
				$activeItem.children('a').first().addClass('nav__link--active').attr('aria-expanded', 'true');
			}
		}

		scrollNavToTop() {
			if (this.$navLinksWrapper.length) {
				this.$navLinksWrapper.animate({ scrollTop: 0 }, 300);
			}
		}

		logExpandedNavHeight($hoveredItem) {
			const $expandedNav = $hoveredItem.find('.nav__list--l2');

			$hoveredItem.siblings('.nav__item--submenu-open').removeClass('nav__item--submenu-open');

			if ($expandedNav.length) {
				const height = $expandedNav.outerHeight();
				$hoveredItem.parent().css('--submenu-height', `${height}px`);
				$hoveredItem.addClass('nav__item--submenu-open');
			} else {
				$hoveredItem.parent().css('--submenu-height', '');
			}
		}

		clearExpandedNavHeight($navContainer) {
			$navContainer.css('--submenu-height', '');
			$navContainer.find('.nav__item').removeClass('nav__item--submenu-open');
		}
	}

	$(document).ready(() => new W4D_Nav());
})(jQuery);
